export const CHECKOUT_LABELS = 'checkout';
export const ACCOUNT_OVERVIEW = 'account.accountOverview';
export const ACCOUNT_COMMON = 'account.common';

export const lblCouponlistAvailable = 'lbl_couponlist_available';
export const lblCouponlistApplied = 'lbl_couponlist_applied';
export const lblCouponCollapsibleHeader = 'lbl_coupon_collapsible_header';
export const lblOffereTittle = 'lbl_offers_title';
export const lblCouponExpiredError = 'lbl_coupon_expired_error';
export const lblCouponlistOnhold = 'lbl_couponlist_onhold';
export const lblCouponValidThru = 'lbl_coupon_validThru';
export const lblCouponlistApplyTobag = 'lbl_couponlist_applyTobag';

export const lblOverviewCouponValid = 'lbl_overview_couponValid';
export const lblCommonAppliedToBag = 'lbl_common_applied_to_bag';
export const lblCouponlistPrintTxt = 'lbl_couponlist_printTxt';
export const lblCouponlistPolicy = 'lbl_couponlist_pPolicy';
export const lblCouponlistLessMoreTxt = 'lbl_couponlist_lessMoreTxt';
export const lblCouponlistShowMoreTxt = 'lbl_couponlist_showMoreTxt';
export const lblCouponlistHelpAppling = 'lbl_couponlist_helpAppling';
export const lblCouponformSubmit = 'lbl_couponform_submit';
export const lblCouponformHeader = 'lbl_couponform_header';
export const lblCouponformHelp = 'lbl_couponform_help';
export const lblCouponformPlaceholder = 'lbl_couponform_placeholder';
export const lblCouponMergecartError = 'lbl_coupon_mergecart_error';
export const lblCouponInvalidFormatError = 'lbl_coupon_invalid_format_error';
export const lblCouponlistUnapplied = 'lbl_couponlist_unapplied';

const CouponLabels = {
  checkout: {
    bagPage: {
      [lblCouponlistAvailable]: 'Available',
      [lblCouponlistApplied]: 'Applied',
      [lblCouponCollapsibleHeader]: 'Rewards & Offers',
      [lblOffereTittle]: 'Offers',
      [lblCouponExpiredError]:
        'The coupon applied  to your order coupon_placeholder is no longer valid. Please remove the coupon to continue',
      [lblCouponlistOnhold]: 'COUPONS ON HOLD',
      [lblCouponValidThru]: 'Valid thru',
      [lblCouponlistApplyTobag]: 'Apply to bag',
      [lblCouponlistPrintTxt]: 'Print',
      [lblCouponlistPolicy]: 'Privacy Policy',
      [lblCouponlistLessMoreTxt]: 'Show less',
      [lblCouponlistShowMoreTxt]: 'Show more',
      [lblCouponlistHelpAppling]: '',
      [lblCouponformSubmit]: 'Apply',
      [lblCouponformHeader]: 'COUPON CODE',
      [lblCouponformHelp]: 'Need help?',
      [lblCouponformPlaceholder]: 'Enter Coupon Code',
      [lblCouponMergecartError]:
        'A coupon previously applied to your cart is no longer applicable. Please review your cart for any changes',
      [lblCouponInvalidFormatError]: 'Please enter a valid promo code',
      [lblCouponlistUnapplied]: 'Unapplied',
    },
  },
  account: {
    accountOverview: {
      [lblOverviewCouponValid]: 'Valid',
    },
    common: {
      [lblCommonAppliedToBag]: 'Applied to Bag',
    },
  },
};
export default CouponLabels;
